import styled from "styled-components";

import { colors } from "@globals";

export const LineupList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const LineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Line = styled.div`
  width: 3px;
  min-height: 20px;
  background-color: black;
  height: calc(50% - 37px);
`;

export const LineupItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: start;
`;

export const Talk = styled.div`
  display: flex;
  // margin-left: 20px;
  margin-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
  align-items: center;
`;

export const Speaker = styled.span`
  font-style: italic;
`;

export const CallTalk = styled.p`
  margin: 0;
  cursor: pointer;
`;

export const Hour = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${colors.main.primary};
`;

export const PictureWrapper = styled.div`
  /* width: 75px;
  height: 75px; */
  overflow: hidden;
`;

export const Picture = styled.img`
  width: 100%;
  height: 75px;
  object-fit: cover;
`;

export const TalkInLine = styled.span`
  color: ${colors.main.primary};
`;

export const NameInLine = styled.span`
  color: ${colors.main.secondary};
`;
